import React from "react";

import FollowUpsDataTable from "./FollowUpsDataTable";

const FollowUpsListPage = () => {
  return (
    <div className="sub-content follow-ups">
      <FollowUpsDataTable />
    </div>
  );
};

export default FollowUpsListPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/list/FollowUpsListPage.js